module.exports = __webpack_public_path__ + "static/media/icon_left.1027f13d.svg";